import React, { useEffect, useState } from 'react'
import { API_URL } from '../../services/url'
import axios from 'axios'
import MyJobs from '../Home/myjobs'
import { JobInfoProps } from './type'
import { Container, Flex, Loader, rem, Text, Title } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'
import { useMediaQuery } from '@mantine/hooks'

export const Bookings = () => {
    const email = localStorage.getItem('user')
    const [loading, setLoading] = useState(true)
    const isMobile = useMediaQuery("(max-width: 600px)");
    const [jobs, setJobs] = useState<JobInfoProps[]>([])
    const [error, setError] = useState('')

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_URL}users-details/joblist/?email=${email}`)
                const jobs = response.data.jobs;

                if (!jobs.length) {
                    setError('Post Not Found');
                    return;
                }

                const upcomingJobs: JobInfoProps[] = [];
                const completedJobs: JobInfoProps[] = [];

                for (const job of jobs) {
                    const { status, occurences = [], repeat_booking } = job;

                    if (status !== "completed" && status !== "cancelled") {
                        // Not completed nor cancelled → upcoming
                        upcomingJobs.push(job);
                    } else if (status === "completed") {
                        if (repeat_booking) {
                            if (occurences.length > 0) {
                                const lastOccurrence = occurences.reduce((latest: any, current: any) =>
                                    new Date(current.occurrence_date) > new Date(latest.occurrence_date)
                                        ? current
                                        : latest
                                );

                                if (lastOccurrence.trip_type === "completed") {
                                    completedJobs.push(job);
                                } else {
                                    upcomingJobs.push(job);
                                }
                            } else {
                                completedJobs.push(job);
                            }
                        } else {
                            completedJobs.push(job);
                        }
                    } else if (status === "cancelled") {
                        completedJobs.push(job);
                    } else if (status === "uncovered") {
                        completedJobs.push(job);
                    }
                }

                const sortedUpcoming = upcomingJobs.sort(
                    (a, b) => new Date(b.pickup_at).getTime() - new Date(a.pickup_at).getTime()
                );

                setJobs([...sortedUpcoming, ...completedJobs]);
                setLoading(false);
            } catch (error: any) {
                setLoading(false);
                setError(error.response?.data?.message || "Error fetching data");
                console.error(error);
            }
        };

        fetchData();
    }, []);

    return (
        <Container
            size={isMobile ? "xs" : "sm"}
            px="lg"
            py={isMobile ? "md" : "xl"}
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "self-start",
                textAlign: "left",
            }}
            bg={"bg"}
        >
            <Flex w={'100%'} align="center" justify={'space-between'} mb="sm" gap="sm">
                <Flex align="center" gap="sm">
                    <IconArrowLeft
                        style={{ width: rem(20), height: rem(20) }}
                        stroke={1.5}
                        onClick={() => window.history.back()}
                        cursor="pointer"
                    />
                    <Title order={2} fw={700}>
                        Booking List
                    </Title>
                </Flex>
            </Flex>
            <Flex w={'100%'} justify={'center'}>
                <Flex direction={'column'} w={'100%'}>
                    {jobs.length !== 0 || error ? jobs.map((job) => (
                        <MyJobs key={job.id} job={job} />
                    )) : <Text size="xl" fw={500} c="black">
                        {loading ? <Flex w={'100%'} h={'100vh'} justify={'center'} align={'center'}> <Loader color="blue" /></Flex> : error}
                    </Text>}
                </Flex>
            </Flex>
        </Container>
    )
}
